module.exports = __webpack_public_path__ + "static/img/sm6.6be6e2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm6.png
// module id = B4yr
// module chunks = 1